import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  HostListener,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import * as $ from "jquery";
import { SearchModelV2 } from "../../models/search-model-v2";
import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {SelectGLCodeV2Component} from "../../utilities/select-gl-code-v2/select-gl-code-v2.component"
import {CompanyV2} from "../../utilities/company-v2/company-v2.component"
import * as moment from 'moment';
import {SearchQueryModel} from "../../models/query.model"

@Component({
  selector: "app-advanced-search-cashbook",
  templateUrl: "./advanced-search-cashbook.component.html",
  styleUrls: ["./advanced-search-cashbook.component.scss"],
})
export class AdvancedSearchCashbookComponent implements OnInit {
  @Input() advSearchModel: SearchModelV2;
  @Input() id: string;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;
  @Output() search = new EventEmitter<any>();


  @ViewChild(SelectGLCodeV2Component) selectGLCodeV2Component : SelectGLCodeV2Component;
  @ViewChild(CompanyV2) companyV2 : CompanyV2;

  companyGuid:any;
  glCodeGuid:any;
  status:any;
  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = "";
  basicSearchQuery = "";
  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];

  // advanced search fields for stock requisition
  docNo = ""
  trackingId=""
  ref=""
  desc=""

  defaultColDef = {
    filter: "agTextColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 200,
    flex: 2,
    sortable: true,
    resizable: true,
    suppressCsvExport: true,
  };

  gridApi;

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent): void {
    this.isAdvanced = false;
  }

  columnsDefs = [
    {
      headerName: "Code",
      field: "code",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Name ",
      field: "name",
      comparator: (valueA, valueB) =>
        valueA.toLowerCase().localeCompare(valueB.toLowerCase()),
      width: 110,
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Phone",
      field: "phone",
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
    {
      headerName: "Email",
      field: "email",
      suppressSizeToFit: true,
      cellStyle: () => ({ "text-align": "left" }),
    },
  ];
  resetListing: boolean = false;
  isEmpty: boolean = true;

  constructor() {
    this.isAdvanced = false;
  }

  ngOnInit(): void {
    this.advForm = this.advSearchModel.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map(
      (e: any) => e.flatMap((f) => f)
    );
    console.log(this.inputArray);
    console.log("label", this.advSearchModel.label)
    this.extractOptions();
    $(document).mouseup((ev) => {
      const container = $(`#${this.id}`);
      const calendar = $("mat-calendar");
      const matOption = $("mat-option");
      const backdrop = $(".cdk-overlay-backdrop");
      if (
        !matOption.is(ev.target) &&
        !calendar.is(ev.target) &&
        !container.is(ev.target) &&
        !backdrop.is(ev.target) &&
        matOption.has(ev.target).length === 0 &&
        container.has(ev.target).length === 0 &&
        calendar.has(ev.target).length === 0 &&
        backdrop.has(ev.target).length === 0
      ) {
        container.hide("fast", "swing", (c) => {
          this.isAdvanced = false;
          // this.advForm.reset();
        });
      }
    });
  }

  extractOptions = (fieldName?, fieldValue?) =>
    this.inputArray
      .filter((x) => x[1] === "select")
      .filter((x) => (fieldName ? x[0] === fieldName : true))
      .forEach((x) => {
        const options = x[2]
          .flatMap((e) => e)
          .filter((e) =>
            fieldValue
              ? e.toLowerCase().includes(fieldValue.toLowerCase())
              : true
          );
        this.optionArray[x[0]] = options;
      });

  onGridReady(params) {
    const apiVisa = AppConfig.apiVisa;
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show("fast", "swing", (c) => (this.isAdvanced = true));
    }
  }


  reset() {
    this.advForm.reset();
    this.resetListing = true;
    this.isEmpty = true;
    this.companyGuid =  null
    this.glCodeGuid = null
    this.viewModelStore.dispatch(this.ColumnViewActions.resetAdvanceSearch());
    if (this.inputArray.some((e) => e.includes("company"))) {
      this.companyV2.onReset();
    }
    if (this.inputArray.some((e) => e.includes("glcode"))) {
      this.selectGLCodeV2Component.onReset();
    }
    this.search.emit(new SearchQueryModel());
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  truncate(str, no_words) {
    return str.split(" ").splice(0, no_words).join(" ");
  }


  basicSearch(e:string) {
    console.log("Search query", e)
    const query = new SearchQueryModel()
    query.keyword = e
    this.search.emit(query);
  }


  advancedSearch() {
    console.log("Running advanced search")
    // cashbookcode cashbookname
    // console.log(this.advForm.get("cashbookname")?.value)
    // console.log(this.advForm.get("cashbookcode")?.value)
    // console.log(this.advForm.value)
    if (this.inputArray.some((e) => e.includes("company"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_Company_Field)
        .subscribe((data) => {
          // console.log("conmmmascmas;ldasm dadta", data)
          this.companyGuid = data ? data.guid : null
        });
    }
    // glcode
    if (this.inputArray.some((e) => e.includes("glcode"))) {
      this.viewModelStore
        .select(this.ColumnViewSelectors.selectAdvanceSearch_GLCode_Field)
        .subscribe((data) => {
          // console.log("conmmmascmas;ldasm dadta", data)
          this.glCodeGuid = data ? data.guid : null 
        });
    }
    //status
    // if (this.inputArray.some((e) => e.includes("status"))) {
    //   this.viewModelStore
    //     .select(this.ColumnViewSelectors.selectAdvanceSearch_Status_Field)
    //     .subscribe((data) => {
    //       console.log("status", data)
    //       this.status = data
    //     });
    // }
    let cashbookName = this.advForm.get("cashbookname")?.value ? this.advForm.get("cashbookname")?.value : null;
    let cashbookCode = this.advForm.get("cashbookcode")?.value ? this.advForm.get("cashbookcode")?.value : null;
    let compGuid = this.companyGuid ? this.companyGuid.toString() : null;
    let glCodeGuid = this.glCodeGuid ? this.glCodeGuid.toString() : null;
    // let stat = this.status ? this.status : "ACTIVE"
    let criteria =  []
    if (cashbookName !== null){
      criteria.push({ columnName: 'name', operator: '=', value: cashbookName })
    }
    if (cashbookCode !== null){
      criteria.push({ columnName: 'code', operator: '=', value: cashbookCode })
    }
    if (compGuid !== null){
      criteria.push({ columnName: 'comp_guid', operator: '=', value: compGuid })
    }
    if (glCodeGuid !== null){
      criteria.push({ columnName: 'glcode_guid', operator: '=', value: glCodeGuid })
    }

    this.search.emit(criteria);
  }

  toggleDropdown() {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}